import {
    request,
    requestPublic
} from './request.js'

// 获取配置列表页
export function GetConfigServer(keyWord,classId,pageIndex,pageSize){
	return request({
		url:'/api2/ZsbSiteAdmin/ApolloOperate/GetAll',
		method:'get',
	})
}

// 添加配置
export function AddConfig(obj){
	return request({
		url:'/api2/ZsbSiteAdmin/ApolloOperate/AddConfig',
		method:'post',
		data:{
			namespaceName: obj.namespaceName,
			key: obj.key,
			value: obj.value,
			comment: obj.comment,
		}
	})
}

// 编辑配置
export function UpConfig(obj){
	return request({
		url:'/api2/ZsbSiteAdmin/ApolloOperate/UpConfig',
		method:'post',
		data:{
			namespaceName: obj.namespaceName,
			key: obj.key,
			value: obj.value,
			comment: obj.comment,
		}
	})
}

// 删除配置
export function DeleteConfig(obj){
	return request({
		url:'/api2/ZsbSiteAdmin/ApolloOperate/DeleteConfig',
		method:'post',
		data:obj
	})
}

// 发布配置
export function PublishConfig(namespaceName){
	return request({
		url:'/api2/ZsbSiteAdmin/ApolloOperate/PublishConfig',
		method:'post',
		params:{
			namespaceName:namespaceName
		}
	})
}